import { createStore } from '../../../../common/Store';
import type { AlgorithmMappingQueryDtoType } from '../../mappings/schema/types';
import { AlgorithmType } from '../../schema/zAlgorithmType';
import { AlgorithmSourceFormDataType } from '../../sources/schema/types';

interface AlgorithmTargetMappingGraphStoreState {
  algorithmTypeCode: AlgorithmType;
  sources: AlgorithmSourceFormDataType[];
  mappings: AlgorithmMappingQueryDtoType[];
  handleRemove?: (index: number) => void;
  readOnly: boolean;
  isLoading?: boolean;
}

export const AlgorithmTargetMappingGraphStore =
  createStore<AlgorithmTargetMappingGraphStoreState>();
